import { render, staticRenderFns } from "./instalacionServicio.vue?vue&type=template&id=2a1599e4&"
import script from "./instalacionServicio.vue?vue&type=script&lang=js&"
export * from "./instalacionServicio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports